import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["column", "container", "count", "canvasFilterLabel"]

  connect() {
    this.sortables = []
    this.observers = []
    this.selectedCanvasId = null
    this.initializeSortables()
    this.observeColumnChanges()
  }

  disconnect() {
    this.sortables.forEach(sortable => sortable.destroy())
    this.sortables = []
    this.observers.forEach(observer => observer.disconnect())
    this.observers = []
  }

  initializeSortables() {
    this.containerTargets.forEach(container => {
      const sortable = Sortable.create(container, {
        group: "hypotheses",
        animation: 150,
        ghostClass: "opacity-50",
        chosenClass: "shadow-lg",
        dragClass: "cursor-grabbing",
        draggable: ".hypothesis-card",
        onEnd: this.handleSortEnd.bind(this)
      })
      this.sortables.push(sortable)
    })
  }

  observeColumnChanges() {
    this.containerTargets.forEach(container => {
      const observer = new MutationObserver(() => this.updateColumnCounts())
      observer.observe(container, { childList: true })
      this.observers.push(observer)
    })
  }

  updateColumnCounts() {
    this.columnTargets.forEach(column => {
      const container = column.querySelector('[data-hypothesis-kanban-target="container"]')
      const countEl = column.querySelector('[data-hypothesis-kanban-target="count"]')
      if (container && countEl) {
        const count = container.querySelectorAll(".hypothesis-card").length
        countEl.textContent = count
      }
    })
  }

  async handleSortEnd(event) {
    const cardElement = event.item
    const hypothesisId = cardElement.dataset.hypothesisId
    const newStatus = event.to.dataset.status
    const newPosition = event.newIndex

    // Skip if nothing changed
    if (event.from === event.to && event.oldIndex === event.newIndex) {
      return
    }

    try {
      const response = await patch(`/workspace/hypotheses/${hypothesisId}/move`, {
        body: JSON.stringify({
          status: newStatus,
          position: newPosition
        }),
        contentType: "application/json",
        responseKind: "json"
      })

      if (!response.ok) {
        const data = await response.json
        console.error("Failed to move hypothesis:", data.error)
        // Revert by refreshing
        window.location.reload()
      }
    } catch (error) {
      console.error("Error moving hypothesis:", error)
      window.location.reload()
    }
  }

  filterByCanvas(event) {
    const button = event.currentTarget
    const canvasId = button.dataset.canvasId
    const label = canvasId ? button.textContent.trim() : "All Canvases"

    this.selectedCanvasId = canvasId

    // Update the filter label
    if (this.hasCanvasFilterLabelTarget) {
      this.canvasFilterLabelTarget.textContent = label
    }

    // Filter the cards
    const cards = document.querySelectorAll(".hypothesis-card")
    cards.forEach(card => {
      if (!canvasId || card.dataset.canvasId === canvasId) {
        card.style.display = ""
      } else {
        card.style.display = "none"
      }
    })
  }

}
